/**
 * Porté depuis apps/web/app/(shop)/livraison/page.tsx (page statique, aucune
 * adaptation nécessaire au-delà de l'abandon de `generateMetadata`, hors
 * périmètre — cf. lot SEO/prérendu séparé).
 */
export function LivraisonPage() {
  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">Livraison</h1>
      <div className="mt-4 max-w-prose space-y-6 font-body text-sm leading-relaxed text-muted">
        <div>
          <h2 className="font-display text-base font-semibold text-ink">Zones couvertes</h2>
          <p className="mt-1">
            VVS livre à Abidjan et dans les grandes villes de Côte d&apos;Ivoire. La disponibilité
            de la livraison pour votre commune est confirmée directement au moment de la commande,
            lorsque vous renseignez votre adresse de livraison.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Délais</h2>
          <p className="mt-1">
            À Abidjan, la livraison s&apos;effectue généralement sous 24&nbsp;heures après
            confirmation de la commande. Dans les autres grandes villes, le délai peut être plus
            long selon la localisation exacte&nbsp;: il vous est communiqué lors de la confirmation
            téléphonique de votre commande.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Frais de livraison</h2>
          <p className="mt-1">
            Les frais de livraison dépendent de votre commune et du volume de votre panier. Ils ne
            sont pas fixes&nbsp;: ils sont calculés automatiquement lorsque vous renseignez votre
            commune de livraison dans le tunnel de commande, avant que vous ne validiez votre
            achat. Le montant exact est donc toujours visible avant paiement, sans surprise à la
            réception.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Confirmation avant expédition</h2>
          <p className="mt-1">
            Une fois votre commande validée, un conseiller vous appelle pour la confirmer avant
            qu&apos;elle ne soit préparée et expédiée. Cette étape permet de vérifier votre adresse
            et les articles commandés, et d&apos;éviter les livraisons manquées.
          </p>
        </div>
      </div>
    </div>
  );
}
